<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">E Resource Development Cell</h1>
    <p class="lead mb-0 text-orange-light">“Revolutionizing Learning with Technology”</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5">
    <div class="col-12 col-lg-7">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-4">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-laptop-code me-2"></i> About E-Resource Cell
        </h3>
        
        <p class="lead text-muted mb-4" style="line-height: 1.8; text-align: justify;">
          The E-Resource Development Cell at our college is dedicated to enhancing the digital learning experience for both students and faculty. Under the expert leadership of <strong>Ms. Nisha</strong>, who serves as the Convener, the cell focuses on the creation, management, and dissemination of electronic educational resources.
        </p>

        <h5 class="fw-bold text-success mb-3">Our Mission</h5>
        <p class="text-muted mb-4" style="line-height: 1.7; text-align: justify;">
          The primary mission of the E-Resource Development Cell is to leverage technology to support and enhance the educational process. By providing access to high-quality digital resources, the cell aims to facilitate interactive learning, foster innovation in teaching methods, and ensure that our academic community stays ahead in the digital age.
        </p>

        <h5 class="fw-bold text-success mb-3">Key Activities</h5>
        <ul class="list-group list-group-flush mb-4">
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Development of Digital Content</strong>: Creating a wide range of digital learning materials, including e-books, online courses, video lectures, and interactive modules.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Resource Management</strong>: Curating and maintaining a repository of electronic resources that are easily accessible to students and faculty.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Training and Support</strong>: Offering workshops and training sessions to help faculty integrate digital tools into their teaching practices.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Collaboration and Partnerships</strong>: Collaborating with other educational institutions and online platforms to expand the range and quality of available resources.</div>
          </li>
        </ul>

        <p class="text-muted border-top pt-3 mb-0" style="line-height: 1.7; text-align: justify;">
          The E-Resource Development Cell is committed to transforming education through digital innovation, making learning more accessible, engaging, and effective for everyone at our college.
        </p>
      </div>

      <!-- Ms Nisha Card -->
      <div class="convener-card p-4 rounded-4 shadow-sm bg-white border-top border-5 border-orange">
        <div class="d-flex align-items-center gap-3">
          <div class="convener-icon-box bg-orange text-white d-flex align-items-center justify-content-center rounded-3 flex-shrink-0">
            <i class="fa-solid fa-user-gear"></i>
          </div>
          <div>
            <h5 class="fw-bold mb-1 text-dark">Ms. Nisha</h5>
            <span class="small text-orange fw-bold text-uppercase tracking-wider">Convener</span>
          </div>
        </div>
        <p class="text-muted mt-3 mb-0" style="line-height: 1.6; text-align: justify;">
          Ms Nisha, the Convener of the E-Resource Development Cell, brings a wealth of experience and a passion for educational technology. Her leadership ensures that the cell not only meets but exceeds its objectives, fostering a vibrant and dynamic learning environment.
        </p>
      </div>
    </div>

    <!-- Right Side Reports Card -->
    <div class="col-12 col-lg-5">
      <div class="sidebar-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-orange mb-4">
        <h4 class="fw-bold mb-4 text-orange-dark border-bottom pb-2">
          <i class="fa-solid fa-file-pdf me-2"></i> Annual E-Resource Reports
        </h4>
        
        <!-- Year Selection Tabs -->
        <ul class="nav nav-pills mb-4 gap-2" id="reportTabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2023-24'" (click)="selectedYear = '2023-24'">2023-24</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2022-23'" (click)="selectedYear = '2022-23'">2022-23</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link py-2 px-3 fw-bold rounded-3" [class.active]="selectedYear === '2021-22'" (click)="selectedYear = '2021-22'">2021-22</button>
          </li>
        </ul>

        <!-- Custom PDF Display Box -->
        <div class="pdf-wrapper shadow-sm border rounded-4 overflow-hidden mb-4 bg-light position-relative">
          <div class="pdf-overlay-action p-3 d-flex align-items-center justify-content-between text-white" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);">
            <span class="fw-bold small"><i class="fa-solid fa-eye me-1"></i> E-Resource Plan ({{ selectedYear }})</span>
            <a [href]="getPdfPath()" download class="btn btn-sm btn-warning text-dark fw-bold border-0"><i class="fa-solid fa-download me-1"></i> Download</a>
          </div>
          <div class="pdf-container-view" style="height: 380px; overflow-y: auto;">
            <pdf-viewer [src]="getPdfPath()" [render-text]="true" [original-size]="false" style="width: 100%; height: 100%; display: block;"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
